module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/palermo.2061db02348e94dcf251fcfccf7e0620.jpg";